export const descriptionListingConstants = {
    LISTING_DESCRIPTION_FAILURE: "LISTING_DESCRIPTION_FAILURE",
    LISTING_DESCRIPTION_SUCCESS: "LISTING_DESCRIPTION_SUCCESS",
}